<template>
  <div class="firmware-page">
    <div class="page-head">
      <div class="left">
        <h1>Manage firmware</h1>
      </div>
    </div>
    <div class="stale-accounts-wrapper">
      <HardwareList ref="HardwareList"/><br><br>
      <FirmwareList ref="FirmwareList" />
    </div>
  </div>
</template>

<script>

import HardwareList from "@/components/Firmware/HardwareList.vue";
import FirmwareList from "@/components/Firmware/FirmwareList.vue";

export default {
  components: {
    FirmwareList,
    HardwareList
  },
  methods: {

  }
};
</script>
<style scoped>
  .stale-accounts-wrapper{
    width: 800px;
  }
</style>
